export default Object.freeze({
  SUBSCRIBED: 0,
  UNSUBSCRIBED: 1,
  ERROR: 2,
});
